// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_SOcNP","formInput":"index_formInput_K11JQ"};